import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';


import { connect } from 'react-redux';
import * as ContractCheckSaga from './Saga/ContractCheck';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
// import { Field, reduxForm ,InjectedFormProps} from 'redux-form';
// // import '../../Css/Table.css';
import Checkbox from '@material-ui/core/Checkbox';
const { CSVLink } = require('react-csv');
// import DatePicker from "react-datepicker";
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');

const headers = [
  { label: "供給地点番号", key: "kyoukyuu_titen_no" },
  { label: "種別", key: "shubetsu" },
  { label: "廃止日", key: "contract_date" },
  { label: "廃止理由", key: "reason" },
  { label: "解体予定日", key: "kaitai_date" },
  { label: "解体予定時刻", key: "kaitai_time" },
  { label: "立合希望日", key: "tatiai_date" },
  { label: "立会予定時刻", key: "tatiai_time" },



];


const headers2 = [
  { label: "供給地点番号", key: "kyoukyuu_titen_no" },
  { label: "種別", key: "shubetsu" },
  { label: "廃止日", key: "contract_date" },
  { label: "廃止理由", key: "reason" },
  { label: "解体予定日", key: "kaitai_date" },
  { label: "解体予定時刻", key: "kaitai_time" },
  { label: "立合希望日", key: "tatiai_date" },
  { label: "立会予定時刻", key: "tatiai_time" },

  { label: "物件", key: "tatemono" },


];


interface Props {
  all_selected: any,
  change_search_form: any,
  search_form: any,
  check_completed: any,
  get_rent_contracts_check_list: any,
  rent_contracts_check_list: any,
  check_completed_cancel: any,
  kyoukyuu_titen_list: any,
  contract_check_download_pint_csv: any,
  // get_rent_contracts: any,
  // change_search_name: any,
  // change_search_contract_date_start: any,
  // change_search_contract_date_end: any,
  // search_contract_date_start: any,
  // search_contract_date_end: any,
  // change_search_tatemono_name: any,
  // handleSubmit:any,
  // onSubmit:any,
  // get_rent_contract_accounting:any,
  // output:any,
  // name:string,
  // date1:string,
  // date2:string
}



interface State {
  reflesh: boolean
}


class Search extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    // this.props.change_search_name("")
    this.state = {
      reflesh: false
    }
    // this.props.change_search_contract_date_end(null)
    this.change_search_name = this.change_search_name.bind(this);

    this.handleContractionDateChange = this.handleContractionDateChange.bind(this);
    this.handleContractionDateChangeEnd = this.handleContractionDateChangeEnd.bind(this);

    this.change_search_tatemono_name = this.change_search_tatemono_name.bind(this);

    this.handle_change_search_completed = this.handle_change_search_completed.bind(this);

  }

  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }
  change_search_name(e: any) {

    let search_form = this.props.search_form
    search_form.search_name = e.target.value

    this.props.change_search_form(search_form)
    this.setState({ reflesh: !this.state.reflesh })
  }

  change_search_tatemono_name(e: any) {
    let search_form = this.props.search_form
    search_form.search_tatemono_name = e.target.value
    this.props.change_search_form(search_form)
    this.setState({ reflesh: !this.state.reflesh })
  }
  handleContractionDateChange(e: any) {
    let search_form = this.props.search_form
    search_form.search_contract_date_start = e
    this.props.change_search_form(search_form)
    this.setState({ reflesh: !this.state.reflesh })
    // this.props.change_search_contract_dat / e_start(e)

  }
  handleContractionDateChangeEnd(e: any) {
    let search_form = this.props.search_form

    search_form.search_contract_date_end = e
    this.props.change_search_form(search_form)
    this.setState({ reflesh: !this.state.reflesh })
    // this.props.change_search_contract_date_end(e)
  }

  handle_change_search_completed(e: any) {

    let search_form = this.props.search_form
    search_form.search_completed = e.target.checked
    if (e.target.checked) {
      let dt = new Date();
      let month = dt.getMonth() + 1;
      //1ヶ月前
      let lastMonth = dt.setMonth(month - 2);
      search_form.search_contract_date_start = lastMonth
      search_form.search_contract_date_end = null
    } else {
      search_form.search_contract_date_start = null
      search_form.search_contract_date_end = null
    }


    this.props.change_search_form(search_form)
    this.setState({ reflesh: !this.state.reflesh })
    this.props.get_rent_contracts_check_list()
  }

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div>

        <table>

          <tbody>

            <tr >

              <td >
                <TextField
                  name="search_name"
                  //   component="input"
                  value={this.props.search_form.search_name}
                  type="text"
                  label="お客様名"
                  onChange={this.change_search_name}
                  className="form-control"
                />

              </td>

              <td >
                <TextField
                  name="search_tatemono_name"
                  value={this.props.search_form.search_tatemono_name}
                  type="text"
                  label="物件名"
                  onChange={this.change_search_tatemono_name}
                  className="form-control"
                />

              </td>
              <td>



                {/* <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.all_selected(true)}
                  className="btn btn-sm btn-warning float-right"
                >全選択</button>

                <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.all_selected(false)}
                  className="btn btn-sm btn-success float-right"
                >全解除</button> */}
              </td>
            </tr>
            <tr >

              <td colSpan={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="contractDataStart"
                    autoOk={true}
                    //    onChange={this.handleContractionDateChangeStart}
                    // value={this.props.search_contract_date_start}
                    value={this.props.search_form.search_contract_date_start}
                    onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    //   minDateMessage="契約日を選択してください"
                    // minDate={new Date("2000-01-01")}
                    invalidDateMessage={"日付の形式が違います"}
                  />
           ～
           <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    style={{ marginLeft: "10px" }}
                    value={this.props.search_form.search_contract_date_end}
                    autoOk={true}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="contractDataEnd"
                    // value={this.props.search_contract_date_end}
                    // //  value={this.props.estimateData.applicationDate}
                    onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.props.search_form.search_completed}
                      onChange={this.handle_change_search_completed}
                      name="search_completed"
                      color="primary"

                    />
                  }
                  label="チェック済"
                  style={{ marginTop: "20px", marginLeft: "60px" }}
                />

                <button
                  type="button"
                  style={{ margin: "20px" }}
                  onClick={this.props.get_rent_contracts_check_list}
                  className="btn btn-primary float-right"
                >検索</button>

                <button
                  type="button"
                  style={{ margin: "20px" }}
                  onClick={this.props.contract_check_download_pint_csv}
                  className="btn btn-success float-right"
                >PINTCSV</button>


                {/* <CSVLink enclosingCharacter={""} headers={headers} filename={"PINT通電廃止リスト.csv"} className="btn btn-success float-right" style={{ margin: "20px" }} data={this.props.kyoukyuu_titen_list} >
                  PINTCSV
</CSVLink> */}
                {/* <CSVLink enclosingCharacter={""} headers={headers2} filename={"PINT通電廃止リスト.csv"} className="btn btn-success float-right" style={{ margin: "20px" }} data={this.props.kyoukyuu_titen_list} >
                  PINTCSV(物件名有)
</CSVLink> */}

                <span className="float-right" style={{ margin: "20px" }}> {this.props.rent_contracts_check_list.length + "件"}</span>
              </td>

              <td colSpan={1}>


                {this.props.search_form.search_completed === false ? <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.check_completed(true)}
                  className="btn btn-sm btn-danger float-right"
                >消込</button> : <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => this.props.check_completed_cancel(true)}
                  className="btn btn-sm btn-warning float-right"
                >取消</button>}
              </td>
            </tr >
          </tbody>
        </table>








      </div >
    );
  }
}




// const mapStateToProps = (state:any) => {
//     return {

//         responseid: state.customersReducer.responseid,
//         responsedetail: state.customersReducer.responsedetail,
//         customerNewDisp: state.customersReducer.customerNewDisp,
//         customerdetail0: state.customersReducer.customerdetail0

//     }
// }
// function mapDispatchToProps(dispatch:any) {
//     return {

//         // responseUpdate(state:any) {
//         //     dispatch(Responses.responseUpdate(state))
//         // },
//         // change_customerloding1(state:number) {
//         //     dispatch(Customers.change_customerloding1(state))
//         // },
//         // change_customerloding2(state:number) {
//         //     dispatch(Customers.change_customerloding2(state))
//         // },
//         // customerNewDispSet(state:number) {
//         //     dispatch(Customers.customerNewDispSet(state))
//         // },
//         // change_customeredit0(state:number) {
//         //     dispatch(Customers.change_customeredit0(state))
//         // },
//        get_rent_contract_accounting(state:any) {
//             dispatch(Monies.get_rent_contract_accounting(state))
//         },

//     };
// }
// AccountingListSearchComponent = connect(
//     mapStateToProps, mapDispatchToProps
// )(AccountingListSearchComponent);

const mapStateToProps = (state: any) => {
  return {
    // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
    shops: state.masterReducer.shops,
    search_form: state.ContractCheck.search_form,
    rent_contracts_check_list: state.ContractCheck.rent_contracts_check_list,
    kyoukyuu_titen_list: state.ContractCheck.kyoukyuu_titen_list,


  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    all_selected(state: any) {
      dispatch(ContractCheckSaga.all_selected(state))
    },
    change_search_form(state: any) {
      dispatch(ContractCheckSaga.change_search_form(state))
    },
    check_completed(state: any) {
      dispatch(ContractCheckSaga.check_completed(state))
    },
    get_rent_contracts_check_list(state: any) {
      dispatch(ContractCheckSaga.get_rent_contracts_check_list(state))
    },
    check_completed_cancel(state: any) {
      dispatch(ContractCheckSaga.check_completed_cancel(state))
    },
    contract_check_download_pint_csv(state: any) {
      dispatch(ContractCheckSaga.contract_check_download_pint_csv(state))
    },

    // change_search_name(state: any) {
    //   dispatch(ContractSearch.change_search_name(state))
    // },
    // change_search_contract_date_start(state: any) {
    //   dispatch(ContractSearch.change_search_contract_date_start(state))
    // },
    // change_search_contract_date_end(state: any) {
    //   dispatch(ContractSearch.change_search_contract_date_end(state))
    // },
    // change_search_tatemono_name(state: any) {
    //   dispatch(ContractSearch.change_search_tatemono_name(state))
    // },
    //   get_banks(state:any) {
    //     dispatch(Kyousai.get_banks(state))
    // },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(AccountingListSearchComponent)

// export default Form;

